export enum PropertyTypeTranslationKey {
    TYPE_STRING = "property.type.string",
    TYPE_CURRENCY = "property.type.currency",
    TYPE_BOOLEAN = "property.type.boolean",
    TYPE_DATE = "property.type.date",
    TYPE_TIME = "property.type.time",
    TYPE_NUMBER = "property.type.number",
}
